[
  {
    "id": "TB-B8-001",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"Sociale media zijn slecht voor jongeren. Ze worden er onzeker van en slapen slechter.\"\n\nIs deze tekst een feit of een mening?",
    "options": [
      "Een mening",
      "Een feit",
      "Allebei",
      "Geen van beide"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-FEIT-MENING-SOCIAL",
    "explanation": "De tekst zegt 'zijn slecht' zonder bewijs. Dat is een mening. Een feit zou zijn: 'Uit onderzoek blijkt dat...'",
    "distractorExplanations": {
      "1": "Er worden geen meetbare gegevens of bronnen genoemd.",
      "2": "De eerste zin is een mening, de tweede is een bewering zonder bewijs.",
      "3": "Het is wel een mening."
    }
  },
  {
    "id": "TB-B8-002",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"In 2023 bezochten 20 miljoen toeristen Amsterdam. De stad heeft 180 musea. Veel bewoners vinden dat het te druk is geworden.\"\n\nWelke zin bevat een feit?",
    "options": [
      "In 2023 bezochten 20 miljoen toeristen Amsterdam",
      "Veel bewoners vinden dat het te druk is geworden",
      "Beide zinnen zijn feiten",
      "Geen van de zinnen is een feit"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-FEIT-MENING-ADAM",
    "explanation": "De eerste zin noemt een meetbaar getal (20 miljoen). Dat is controleerbaar en dus een feit. 'Te druk' is een mening.",
    "distractorExplanations": {
      "1": "'Vinden dat' en 'te druk' zijn signaalwoorden voor een mening.",
      "2": "De laatste zin is een mening (bewoners vinden iets).",
      "3": "De eerste zin is wel een feit."
    }
  },
  {
    "id": "TB-B8-003",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"De Amazone is het grootste regenwoud ter wereld. Elk jaar verdwijnt er een stuk zo groot als België door ontbossing. Wetenschappers waarschuwen dat dit ernstige gevolgen heeft voor het klimaat. Toch gaat de houtkap door.\"\n\nWat is de beste samenvatting?",
    "options": [
      "Het Amazone-regenwoud wordt bedreigd door ontbossing, wat slecht is voor het klimaat",
      "België is een klein land",
      "Wetenschappers doen onderzoek in het regenwoud",
      "Houtkap levert veel geld op"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "samenvatten",
    "familyId": "TB-SAMENVATTEN-AMAZONE",
    "explanation": "De tekst gaat over ontbossing van de Amazone en de gevolgen voor het klimaat. Dat is de kern.",
    "distractorExplanations": {
      "1": "België wordt alleen als vergelijking gebruikt voor de grootte.",
      "2": "Onderzoek wordt niet als hoofdonderwerp besproken.",
      "3": "Geld wordt niet in de tekst genoemd."
    }
  },
  {
    "id": "TB-B8-004",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"Hoewel veel mensen denken dat goudvissen een geheugen van 3 seconden hebben, is dat niet waar. Onderzoek toont aan dat goudvissen zich dingen tot 5 maanden kunnen herinneren.\"\n\nWat is de tekststructuur?",
    "options": [
      "Misverstand weerleggen (eerst fout idee, dan de waarheid)",
      "Opsomming van feiten",
      "Probleem en oplossing",
      "Vergelijking van twee dieren"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "tekststructuur",
    "familyId": "TB-STRUCTUUR-GOUDVIS",
    "explanation": "De tekst begint met een veelvoorkomend misverstand ('veel mensen denken') en weerlegt dat vervolgens met onderzoek.",
    "distractorExplanations": {
      "1": "Het is geen opsomming, maar een weerlegging.",
      "2": "Er is geen probleem dat opgelost wordt.",
      "3": "Er worden geen twee dieren vergeleken."
    }
  },
  {
    "id": "TB-B8-005",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"Kunstmatige intelligentie (AI) wordt steeds beter. Sommigen zien het als een kans: AI kan gevaarlijk werk overnemen. Anderen zien het als een bedreiging: mensen verliezen hun baan.\"\n\nWelke conclusie kun je trekken?",
    "options": [
      "Er zijn verschillende meningen over AI",
      "AI is alleen maar goed",
      "AI is alleen maar slecht",
      "Niemand weet wat AI is"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CONCLUSIE-AI",
    "explanation": "De tekst presenteert twee kanten: 'sommigen zien het als een kans' en 'anderen zien het als een bedreiging'. Er zijn dus verschillende meningen.",
    "distractorExplanations": {
      "1": "De tekst noemt ook nadelen.",
      "2": "De tekst noemt ook voordelen.",
      "3": "De tekst legt uit wat AI kan, dus mensen weten er wel iets van."
    }
  },
  {
    "id": "TB-B8-006",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Welke zin is een feit?\n\n1. \"Voetbal is de leukste sport.\"\n2. \"De Eredivisie heeft 18 clubs.\"\n3. \"Ajax speelt het mooiste voetbal.\"\n4. \"Feyenoord heeft de beste supporters.\"",
    "options": [
      "Zin 2",
      "Zin 1",
      "Zin 3",
      "Zin 4"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-FEIT-VOETBAL",
    "explanation": "Zin 2 is controleerbaar: je kunt natellen hoeveel clubs er in de Eredivisie zitten. De andere zinnen bevatten woorden als 'leukste', 'mooiste' en 'beste' — dat zijn meningen.",
    "distractorExplanations": {
      "1": "'Leukste' is een waardeoordeel, dus een mening.",
      "2": "'Mooiste' is een waardeoordeel, dus een mening.",
      "3": "'Beste' is een waardeoordeel, dus een mening."
    }
  },
  {
    "id": "TB-B8-007",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"Water kookt bij 100°C op zeeniveau. In de bergen kookt water bij een lagere temperatuur. Dit komt doordat de luchtdruk op grote hoogte lager is.\"\n\nWat is de oorzaak dat water in de bergen bij een lagere temperatuur kookt?",
    "options": [
      "De lagere luchtdruk op grote hoogte",
      "Het koudere weer in de bergen",
      "Het schonere water in de bergen",
      "De wind op de bergtop"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "oorzaak_gevolg",
    "familyId": "TB-OORZAAK-KOKEN",
    "explanation": "De tekst zegt: 'Dit komt doordat de luchtdruk op grote hoogte lager is.' Het signaalwoord 'doordat' geeft de oorzaak aan.",
    "distractorExplanations": {
      "1": "Het weer wordt niet als oorzaak genoemd.",
      "2": "De kwaliteit van het water wordt niet genoemd.",
      "3": "Wind wordt niet in de tekst genoemd."
    }
  },
  {
    "id": "TB-B8-008",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"De schoolbibliotheek heeft 2.000 boeken. Vorig jaar werden er 500 nieuwe boeken aangeschaft. Helaas raken er ook elk jaar boeken zoek. De bibliothecaris vindt dat leerlingen beter op de boeken moeten passen.\"\n\nWelke zin bevat een mening?",
    "options": [
      "De bibliothecaris vindt dat leerlingen beter op de boeken moeten passen",
      "De schoolbibliotheek heeft 2.000 boeken",
      "Vorig jaar werden er 500 nieuwe boeken aangeschaft",
      "Er raken elk jaar boeken zoek"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "feit_mening",
    "familyId": "TB-FEIT-BIEB",
    "explanation": "'Vindt dat' is een signaal voor een mening. De bibliothecaris geeft zijn/haar persoonlijke oordeel.",
    "distractorExplanations": {
      "1": "Dit is een controleerbaar feit (je kunt de boeken tellen).",
      "2": "Dit is een controleerbaar feit (aankoopgegevens).",
      "3": "Dit is een feit (het gebeurt daadwerkelijk)."
    }
  },
  {
    "id": "TB-B8-009",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Lees de tekst:\n\n\"Plastic soep is een groeiend probleem. In de oceanen drijven miljarden stukjes plastic. Zeedieren eten het plastic en worden ziek. Uiteindelijk komt het plastic via vis ook op ons bord terecht.\"\n\nWat is de beste samenvatting in één zin?",
    "options": [
      "Plastic in de oceanen is schadelijk voor zeedieren en uiteindelijk ook voor mensen",
      "Er drijven miljarden stukjes plastic in de zee",
      "Vis is ongezond om te eten",
      "Zeedieren worden ziek van plastic"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "samenvatten",
    "familyId": "TB-SAMENVATTEN-PLASTIC",
    "explanation": "De tekst beschrijft de keten: plastic → zeedieren → mensen. De beste samenvatting vangt de hele keten.",
    "distractorExplanations": {
      "1": "Dit is een detail uit de tekst, niet de volledige samenvatting.",
      "2": "De tekst zegt niet dat vis ongezond is, maar dat plastic in vis terecht kan komen.",
      "3": "Dit is slechts een deel van het verhaal."
    }
  },
  {
    "id": "TB-B8-010",
    "module": "Taalbegrip",
    "difficulty": 301,
    "question": "Wat betekent het woord 'chronologisch' in de zin: 'De gebeurtenissen staan in chronologische volgorde.'",
    "options": [
      "In tijdsvolgorde (van vroeg naar laat)",
      "Van groot naar klein",
      "Op alfabet",
      "Van belangrijk naar onbelangrijk"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-CHRONOLOGISCH",
    "explanation": "'Chronologisch' komt van het Griekse woord 'chronos' (tijd). Het betekent: in de volgorde van de tijd.",
    "distractorExplanations": {
      "1": "Dat zou 'op grootte' zijn.",
      "2": "Dat zou 'alfabetisch' zijn.",
      "3": "Dat zou 'op relevantie' zijn."
    }
  }
]